import React from 'react';
import styled, { keyframes } from 'styled-components';

import { colors } from '../../../assets/settings';

const LoadingSpinner = (props) => {

  return (
    <StyledLoadingSpinner
      color={props.color || colors.bodyText}
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </StyledLoadingSpinner>
  );
}

const dot1 = keyframes`
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
`;

const dot2 = keyframes`
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
`;

const dot3 = keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
`;

const StyledLoadingSpinner = styled.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  & > div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: ${props => props.color};
    animation-timing-function: cubic-bezier(0, 1, 1, 0);


    &:nth-child(1) {
      left: 8px;
      animation: ${dot1} 0.6s infinite;
    }

    &:nth-child(2) {
      left: 8px;
      animation: ${dot2} 0.6s infinite;
    }

    &:nth-child(3) {
      left: 32px;
      animation: ${dot2} 0.6s infinite;
    }

    &:nth-child(4) {
      left: 56px;
      animation: ${dot3} 0.6s infinite;
    }
  }
`;


export default LoadingSpinner;
